var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 65,
    viewBox: "0 0 52 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_779_",
    transform: "translate(-44.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_484_",
    transform: "translate(44.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_581_",
    d: "M90.4,121.458H66.96a7.435,7.435,0,0,0,1.742-4.8,7.1,7.1,0,1,0-14.185,0,7.435,7.435,0,0,0,1.742,4.8h-5.6a6.243,6.243,0,0,0-6.132,6.334v7.475a1.227,1.227,0,1,0,2.453,0v-7.475a3.746,3.746,0,0,1,3.679-3.8H85a3.746,3.746,0,0,1,3.679,3.8v6.841H75.928a6.338,6.338,0,0,0,0,12.669H88.683v6.841a3.746,3.746,0,0,1-3.679,3.8H50.664a3.746,3.746,0,0,1-3.679-3.8v-7.485a1.227,1.227,0,1,0-2.453,0v7.485a6.243,6.243,0,0,0,6.132,6.335H90.4a6.243,6.243,0,0,0,6.132-6.335V127.792A6.243,6.243,0,0,0,90.4,121.458Zm-28.79-9.595a4.8,4.8,0,1,1-4.64,4.793A4.724,4.724,0,0,1,61.61,111.863Zm28.3,12.128H90.4a3.746,3.746,0,0,1,3.679,3.8v6.841H91.136v-6.841A6.439,6.439,0,0,0,89.906,123.991ZM72.249,140.968a3.746,3.746,0,0,1,3.679-3.8H94.079v7.6H75.928A3.746,3.746,0,0,1,72.249,140.968ZM90.4,157.944h-.494a6.439,6.439,0,0,0,1.23-3.8V147.3h2.943v6.841A3.746,3.746,0,0,1,90.4,157.944Z",
    transform: "translate(-44.532 -95.478)",
    fill: "#19d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1260_",
    d: "M289.2,349.062a1.217,1.217,0,0,0-.868.371,1.3,1.3,0,0,0,0,1.791,1.2,1.2,0,0,0,1.735,0,1.3,1.3,0,0,0,0-1.791A1.216,1.216,0,0,0,289.2,349.062Z",
    transform: "translate(-258.116 -304.839)",
    fill: "#19d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1711_",
    d: "M278.544,36.649a7.331,7.331,0,1,0-7.093-7.327A7.221,7.221,0,0,0,278.544,36.649Zm0-12.12a4.8,4.8,0,1,1-4.64,4.793A4.724,4.724,0,0,1,278.544,24.53Z",
    transform: "translate(-243.621 -19.209)",
    fill: "#19d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1712_",
    d: "M222.839,12.489a1.247,1.247,0,0,0,1.226-1.267V1.267a1.227,1.227,0,1,0-2.453,0v9.955A1.247,1.247,0,0,0,222.839,12.489Z",
    transform: "translate(-199.896)",
    fill: "#19d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1757_",
    d: "M174.839,8.108a1.247,1.247,0,0,0,1.226-1.267V1.267a1.227,1.227,0,1,0-2.453,0V6.841A1.247,1.247,0,0,0,174.839,8.108Z",
    transform: "translate(-157.782)",
    fill: "#19d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1760_",
    d: "M45.758,351.6a1.216,1.216,0,0,0,.867-.371,1.3,1.3,0,0,0,0-1.791,1.2,1.2,0,0,0-1.734,0,1.3,1.3,0,0,0,0,1.791A1.216,1.216,0,0,0,45.758,351.6Z",
    transform: "translate(-44.532 -304.839)",
    fill: "#19d2d2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFees);
export default __webpack_public_path__ + "static/media/fees.50cb4df64f8a9bf5673e68dcadca497b.svg";
export { ForwardRef as ReactComponent };